import React, { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import api from "@/lib/api";

export default function ShareStatsCard() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/admin/share-stats?months=6").then(({ data }) => setD(data)).catch(() => {}); }, []);
  if (!d) return null;
  const t = d.totals;
  const rate = t.claimed ? Math.round((t.redeemed / t.claimed) * 100) : 0;
  return (
    <div className="bg-white rounded-3xl soft-shadow p-6 mb-4" data-testid="share-stats-card">
      <h3 className="font-display font-bold text-[#19324A] mb-1 inline-flex items-center gap-2"><Share2 className="w-4 h-4" /> Share rewards</h3>
      <p className="text-xs text-[#19324A]/50 mb-4">Shoppers who share a product to Facebook can claim a single-use SHARE5 code (5% off, 30 days). Here's how many were claimed and redeemed.</p>
      <div className="grid grid-cols-3 gap-3 mb-4">
        {[["Claimed", t.claimed, "share-stat-claimed"], ["Redeemed", t.redeemed, "share-stat-redeemed"], ["Live now", t.live, "share-stat-live"]].map(([l, v, tid]) => (
          <div key={l} className="rounded-2xl bg-[#FFF9EE] p-3 text-center"><p className="font-display font-extrabold text-2xl text-[#19324A]" data-testid={tid}>{v}</p><p className="text-[11px] font-bold uppercase tracking-wider text-[#19324A]/50">{l}</p></div>
        ))}
      </div>
      <table className="w-full text-sm" data-testid="share-stats-table">
        <thead><tr className="text-left text-[11px] uppercase tracking-wider text-[#19324A]/50"><th className="py-1">Month</th><th className="py-1 text-right">Claimed</th><th className="py-1 text-right">Redeemed</th></tr></thead>
        <tbody>
          {d.months.map((m) => (
            <tr key={m.month} className="border-t border-[#19324A]/8" data-testid={`share-stats-row-${m.month}`}>
              <td className="py-1.5 text-[#19324A]">{m.month_label}</td>
              <td className="py-1.5 text-right font-bold text-[#19324A]">{m.claimed}</td>
              <td className="py-1.5 text-right font-bold text-[#2E9E5B]">{m.redeemed}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <p className="text-[11px] text-[#19324A]/45 mt-2">Redemption rate overall: {rate}%.</p>
    </div>
  );
}
